import { Page, Badge, Layout, ExceptionList, LegacyCard, EmptyState } from '@shopify/polaris';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { getSellById, deleteSellById, postInvoice, getSellsStockById } from '../../../services/sellsService';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';
import ToastContext from '../../../context/ToastContext';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import fillZeros from '../../../helpers/fillZeros';
import ViewSellPrimaryActions from '../../UI/Sells/ViewSellPrimaryActions';
import SellNumbers from '../../UI/Sells/SellNumbers';
import AddStockCard from '../../UI/Sells/AddStockCard';
import ProductsWrapper from '../../UI/Products/ProductsWrapper';
import SellStockTable from '../../UI/Tables/SellStockTable';

const Sell = () => {
  const { id } = useParams();
  const history = useHistory();
  const [sell, setSell] = useState(null);
  const [stock, setStock] = useState(null);
  const [, dispatchToast] = useContext(ToastContext);

  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : '/sell';
  const canDelete = sell && sell.status === 'DRAFT';
  const TableComponent = (args) => <SellStockTable {...args} sell={sell} />;

  const getSellStock = (page = 1, limit = 10, refresh = false) => {
    getSellsStockById(id, { page, limit }).then((r) => setStock({ ...r.data, new: refresh }));
  };

  const getSell = () =>
    getSellById(id).then((r) => {
      setSell(r.data);
      getSellStock(1, 10, true);
    });

  useEffect(() => {
    getSell();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = () =>
    window.confirm(
      'Esta acción es irreversible.\nLa mercancía volverá a su depósito de origen.\n\n¿Estás seguro de que deseas borrar el albarán?',
    ) &&
    deleteSellById(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const handleInvoice = () =>
    window.confirm('¿Desea facturar y cerrar el albaránb?\n\nUna vez facturado, no se podrá modificar el albarán') &&
    postInvoice(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        getSell();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const handleStockAdded = (product) => {
    setStock({
      ...stock,
      data: [product],
      update: true,
    });
    getSell();
  };

  return <>
    {sell && (
      <Page
        backAction={{ content: 'Volver', url: returnUrl }}
        title={`#${fillZeros(sell.id, 4)}`}
        titleMetadata={
          sell.status === 'DRAFT' && (
            <ExceptionList
              items={[
                {
                  icon: HorizontalDotsMinor,
                  status: 'warning',
                  title: 'Borrador',
                },
              ]}
            />
          )
        }
        subtitle={
          <span className="block">
            <span className="inline-block">{`${sell.deposit.name} ⇢ ${sell.customer.name}`}</span>
            <span className="inline-block ml-4">
              {sell.status === 'INVOICED' && <Badge status="new">Facturado</Badge>}
            </span>
          </span>
        }
        primaryAction={
          <ViewSellPrimaryActions
            stock={stock ? stock.data : []}
            status={sell.status}
            onInvoice={handleInvoice}
            onDelete={handleDelete}
          />
        }
        divider
      >
        <Layout>
          <SellNumbers sell={sell} />
          {canDelete && (
            <Layout.Section>
              <AddStockCard sell={sell} onStockAdded={handleStockAdded} />
            </Layout.Section>
          )}
          <Layout.Section>
            {stock && !stock.data.length && (
              <LegacyCard>
                <LegacyCard.Section>
                  <EmptyState
                    heading="Todavía no se ha añadido mercancía"
                    image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                  ></EmptyState>
                </LegacyCard.Section>
              </LegacyCard>
            )}
            {stock && (
              <ProductsWrapper
                data={stock}
                TableComponent={TableComponent}
                loadPage={() => getSellStock(stock.metadata.page + 1)}
              />
            )}
          </Layout.Section>
        </Layout>
      </Page>
    )}
  </>;
};

export default Sell;
